module.exports = __webpack_public_path__ + "static/media/bag.819c4375.svg";